import Home from '../routes/home';
import { MyModal } from './modal/MyModal';
import { useEffect, useRef } from 'preact/hooks';
import BeaconAction from '@tencent/beacon-web-sdk';
import useInitialApp from '../hooks/useInitialApp';
import PostHaiForm from './postHaiForm/PostHaiForm';
import { getChannelSource } from './app.util';
import { addClubCls } from '../utils/common';
import style from '../routes/home/style.scss';
import useReport from '../hooks/useReport';
import urlUtils from '../utils/urlUtils';

// 判断没有被嵌入
const embeddedLoader = urlUtils.isEmbeddedLoader();

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function App() {
  const beaconAction = useRef(null);
  const hideAccountLimitTip = new URLSearchParams(location.search).get('hideAccountLimitTip') === 'true';
  const { config, postRegionUrlParams = {}, errorMsg, handleHaiStart, haiLoadingInfo, haiErrorTitle } = useInitialApp();
  const { isNormal } = getChannelSource();
  if (!embeddedLoader) {
    useReport(config, beaconAction);
  }
  useEffect(() => {
    let success = () => {
      // console.log(`onReportSuccess : ${e}`);
    };
    let fail = (e) => {
      console.log(`onReportFail : ${e}`);
    };
    let ba = new BeaconAction({
      appkey: process.env.NODE_ENV === 'development' ? '0WEB059WKIKKGX47' : '0WEB059WKIC6P9MF', // 灯塔官网配置的项目key值 测试/生产
      versionCode: '2.5', //项目版本,选填
      strictMode: false, //严苛模式开关, 打开严苛模式会主动抛出异常, 上线请务必关闭!!!
      sessionDuration: 60 * 1000, // session变更的时间间隔, 一个用户持续30分钟(默认值)没有任何上报则算另一次 session,每变更一次session上报一次启动事件(rqd_applaunched),使用毫秒(ms),最小值30秒,选填
      isOversea: false, // true为海外版，false为国内版，默认为国内版，选填
      needQueryConfig: true, //是否请求下发策略，默认是，选填
      onReportSuccess: success,
      onReportFail: fail,
    });
    beaconAction.current = ba;
  }, []);

  return (
    <div id='app' className={addClubCls(style, 'app')}>
      <Home
        config={config}
        beaconAction={beaconAction}
        error={errorMsg}
        haiLoadingInfo={haiLoadingInfo}
        haiErrorTitle={haiErrorTitle}
        handleHaiStart={handleHaiStart}
      />
      <div id='modal-root' />
      {
        // 协作模式参与者不需要校验账号欠费信息
        !config.isPartner && config.paymentEnabled && !hideAccountLimitTip && isNormal && <MyModal config={config} />
      }
      <PostHaiForm
        {...postRegionUrlParams}
        config={config}
        beaconAction={beaconAction}
        spaceKey={haiLoadingInfo.spaceKey}
      />
    </div>
  );
}

export default App;
